import React from 'react'
import Card from '../components/Card'
import servicesData from '../data/servicesData'

export default function Initiatives() {
  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-2">
          <h1>Our Initiatives</h1>
          <p className="breadcrumb">Home › Initiatives</p>
        </div>
      </div>

      <section className="py-16" style={{background:'var(--cream)'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center'}}>Sewa Bharti Haryana Pradesh</div>
            <h2 className="mb-4" style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(28px,4vw,44px)',fontWeight:700,color:'var(--navy)'}}>Our Initiatives</h2>
            <p className="mx-auto" style={{fontSize:'16px',color:'var(--muted)',maxWidth:'560px',lineHeight:1.8}}>
              Transforming lives across Haryana through focused, compassionate programs that address the root causes of poverty and inequality.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {servicesData.map((s, i) => <Card key={s.slug} {...s} index={i}/>)}
          </div>
        </div>
      </section>
    </div>
  )
}
